.emptyContainer {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.emptyMessage {
  user-select: none;
  opacity: 0.6;
  pointer-events: none;
}

.container {
  width: 100%;
  position: relative;
}

.rateControl {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  min-width: 0;
  z-index: 1;
  display: flex;
  align-items: center;
}

.rateLabel {
  cursor: pointer;
  color: var(--tuna-palette-secondary-main);
  padding-left: 8px;
  padding-right: 8px;
  user-select: none;
  background-color: var(--tuna-palette-background-paper);
  font-size: 12px;
  font-weight: 500;
}

.sliderContainer {
  margin-left: 8px;
  background-color: var(--tuna-palette-background-paper);
  opacity: 0.9;
  border-radius: 8px;
  padding: 8px;
  min-width: 120px;
  display: flex;
  align-items: center;
}

.slider {
  width: 100px;
  margin-left: 8px;
  margin-right: 8px;
}
